import React from 'react';

const KeepHistoricalWarningMessage: React.FC<{ keep: boolean; type: 'flow' | 'metric' }> = (
  { keep, type } = { keep: false, type: 'flow' },
) => {
  let content = (
    <>
      <div>With historical data retained, your metric baseline may</div>
      <div>change. This change will impact data going forward.</div>
    </>
  );
  if (!keep) {
    content = (
      <>
        <div>
          Are you sure you want to <span style={{ color: '#F5222D' }}>remove historical data</span>{' '}
          (this
        </div>
        <div>cannot be restored)? After deployment, changes to the</div>
        <div>{type} will only apply to incoming data.</div>
      </>
    );
  }
  return <div>{content}</div>;
};

export default KeepHistoricalWarningMessage;
